<template>
  <div class="container">
    <!-- If you want to hide survey, comment the lines below -->
    <survey :survey="survey"></survey>
    
  </div>
  
</template>

<script>

import * as SurveyVue from "survey-vue";
import "bootstrap/dist/css/bootstrap.css";





var Survey = SurveyVue.Survey;
//Survey.cssType = "bootstrap";

SurveyVue
    .StylesManager
    .applyTheme("bootstrap");

SurveyVue.defaultBootstrapCss.navigationButton = "btn btn-blue";


/*var defaultThemeColors = Survey
    .StylesManager
    .ThemeColors["default"];
defaultThemeColors["$main-color"] = "#7ff07f";
defaultThemeColors["$main-hover-color"] = "#6fe06f";
defaultThemeColors["$text-color"] = "#4a4a4a";
defaultThemeColors["$header-color"] = "#7ff07f";

defaultThemeColors["$header-background-color"] = "#4a4a4a";
defaultThemeColors["$body-container-background-color"] = "#f8f8f8";
*/
/*Survey
    .StylesManager
    .applyTheme("default");*/



import * as widgets from "surveyjs-widgets";

import { init as customWidget } from "../components/customwidget";

// widgets.icheck(SurveyVue);
widgets.select2(SurveyVue);
widgets.inputmask(SurveyVue);
widgets.jquerybarrating(SurveyVue);
widgets.jqueryuidatepicker(SurveyVue);
widgets.nouislider(SurveyVue);
widgets.select2tagbox(SurveyVue);
widgets.sortablejs(SurveyVue);
widgets.ckeditor(SurveyVue);
widgets.autocomplete(SurveyVue);
widgets.bootstrapslider(SurveyVue);
customWidget(SurveyVue);


export default {
  components: {
    Survey
  },
  data() {
    var json = {
    title: " ",
    locale: "pt-br",
    progressBarType: "buttons",
    showProgressBar: "top",
    triggers: [
      //Classificação
      {
        type: "setvalue",
        expression: "{tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} <= 70",
        setToName: "classificacao2",
        setValue: "Prescritor"
      },

      {
        type: "setvalue",
        expression: "{tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} >= 130",
        setToName: "classificacao2",
        setValue: "KOL Nacional"
      },
      {
        type: "setvalue",
        expression: "{tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} <= 130 and {tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} >= 70 and {tempo} >= 20",
        setToName: "classificacao2",
        setValue: "KOL Regional"
      },
      {
        type: "setvalue",
        expression: "{tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} <= 130 and {tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} > 70 and {tempo} <= 20 and {pos_graduacao} = 1 and {associado} = 1",
        setToName: "classificacao2",
        setValue: "Rising Star"
      },
      //exceçãp
      {
        type: "setvalue",
        expression: "{classificacao2} empty",
        setToName: "classificacao2",
        setValue: "KOL Regional"
      },

      //Prescritor
      {
        type: "setvalue",
        expression: "{classificacao2} = 'Prescritor' and {job}='1'",
        setToName: "val",
        setValue: "2000"
      },
      //KOL Nacional
      {
        type: "setvalue",
        expression: "{classificacao2} = 'KOL Nacional' and {job}='1'",
        setToName: "val",
        setValue: "4000"
      },
      //KOL Regional
      {
        type: "setvalue",
        expression: "{classificacao2} = 'KOL Regional' and {job}='1'",
        setToName: "val",
        setValue: "2500"
      },
      //Rising Star
      {
        type: "setvalue",
        expression: "{classificacao2} = 'Rising Star' and {job}='1'",
        setToName: "val",
        setValue: "3000"
      },
            //Prescritor
            {
              type: "setvalue",
              expression: "{classificacao2} = 'Prescritor' and {job}='2'",
              setToName: "val",
              setValue: "2000"
            },
            //KOL Nacional
            {
              type: "setvalue",
              expression: "{classificacao2} = 'KOL Nacional' and {job}='2'",
              setToName: "val",
              setValue: "5000"
            },
            //KOL Regional
            {
              type: "setvalue",
              expression: "{classificacao2} = 'KOL Regional' and {job}='2'",
              setToName: "val",
              setValue: "3000"
            },
            //Rising Star
            {
              type: "setvalue",
              expression: "{classificacao2} = 'Rising Star' and {job}='2'",
              setToName: "val",
              setValue: "4000"
            },
                  //Prescritor
      {
        type: "setvalue",
        expression: "{classificacao2} = 'Prescritor' and {job}='3'",
        setToName: "val",
        setValue: "1750"
      },
      //KOL Nacional
      {
        type: "setvalue",
        expression: "{classificacao2} = 'KOL Nacional' and {job}='3'",
        setToName: "val",
        setValue: "3500"
      },
      //KOL Regional
      {
        type: "setvalue",
        expression: "{classificacao2} = 'KOL Regional' and {job}='3'",
        setToName: "val",
        setValue: "2500"
      },
      //Rising Star
      {
        type: "setvalue",
        expression: "{classificacao2} = 'Rising Star' and {job}='3'",
        setToName: "val",
        setValue: "3000"
      },
            //Prescritor
            {
              type: "setvalue",
              expression: "{classificacao2} = 'Prescritor' and {job}='4'",
              setToName: "val",
              setValue: "2000"
            },
            //KOL Nacional
            {
              type: "setvalue",
              expression: "{classificacao2} = 'KOL Nacional' and {job}='4'",
              setToName: "val",
              setValue: "4500"
            },
            //KOL Regional
            {
              type: "setvalue",
              expression: "{classificacao2} = 'KOL Regional' and {job}='4'",
              setToName: "val",
              setValue: "3000"
            },
            //Rising Star
            {
              type: "setvalue",
              expression: "{classificacao2} = 'Rising Star' and {job}='4'",
              setToName: "val",
              setValue: "3500"
            },
                  //Prescritor
      {
        type: "setvalue",
        expression: "{classificacao2} = 'Prescritor' and {job}='5'",
        setToName: "val",
        setValue: "2000"
      },
      //KOL Nacional
      {
        type: "setvalue",
        expression: "{classificacao2} = 'KOL Nacional' and {job}='5'",
        setToName: "val",
        setValue: "5000"
      },
      //KOL Regional
      {
        type: "setvalue",
        expression: "{classificacao2} = 'KOL Regional' and {job}='5'",
        setToName: "val",
        setValue: "3000"
      },
      //Rising Star
      {
        type: "setvalue",
        expression: "{classificacao2} = 'Rising Star' and {job}='5'",
        setToName: "val",
        setValue: "4000"
      },
            //Prescritor
            {
              type: "setvalue",
              expression: "{classificacao2} = 'Prescritor' <= 70 and {job}='6'",
              setToName: "val",
              setValue: "2000"
            },
            //KOL Nacional
            {
              type: "setvalue",
              expression: "{classificacao2} = 'KOL Nacional' and {job}='6'",
              setToName: "val",
              setValue: "5000"
            },
            //KOL Regional
            {
              type: "setvalue",
              expression: "{classificacao2} = 'KOL Regional' and {job}='6'",
              setToName: "val",
              setValue: "3000"
            },
            //Rising Star
            {
              type: "setvalue",
              expression: "{classificacao2} = 'Rising Star' and {job}='6'",
              setToName: "val",
              setValue: "4000"
            },
                  //Prescritor
      {
        type: "setvalue",
        expression: "{classificacao2} = 'Prescritor' and {job}='7'",
        setToName: "val",
        setValue: "2000"
      },
      //KOL Nacional
      {
        type: "setvalue",
        expression: "{classificacao2} = 'KOL Nacional' and {job}='7'",
        setToName: "val",
        setValue: "5000"
      },
      //KOL Regional
      {
        type: "setvalue",
        expression: "{classificacao2} = 'KOL Regional' and {job}='7'",
        setToName: "val",
        setValue: "3000"
      },
      //Rising Star
      {
        type: "setvalue",
        expression: "{classificacao2} = 'Rising Star' and {job}='7'",
        setToName: "val",
        setValue: "4000"
      },
      {
              type: "setvalue",
              expression: "{job}='8'",
              setToName: "ph2",
              setValue: "valores por hora."
            },
            //Prescritor
            {
              type: "setvalue",
              expression: "{classificacao2} = 'Prescritor' and {job}='8'",
              setToName: "val",
              setValue: "500"
            },
            //KOL Nacional
            {
              type: "setvalue",
              expression: "{classificacao2} = 'KOL Nacional' and {job}='8'",
              setToName: "val",
              setValue: "1000"
            },
            //KOL Regional
            {
              type: "setvalue",
              expression: "{classificacao2} = 'KOL Regional' and {job}='8'",
              setToName: "val",
              setValue: "750"
            },
            //Rising Star
            {
              type: "setvalue",
              expression: "{classificacao2} = 'Rising Star' and {job}='8'",
              setToName: "val",
              setValue: "900"
            },

                  //Prescritor
      {
        type: "setvalue",
        expression: "{classificacao2} = 'Prescritor' and {job}='9'",
        setToName: "val",
        setValue: "2500"
      },
      //KOL Nacional
      {
        type: "setvalue",
        expression: "{classificacao2} = 'KOL Nacional' and {job}='9'",
        setToName: "val",
        setValue: "10000"
      },
      //KOL Regional
      {
        type: "setvalue",
        expression: "{classificacao2} = 'KOL Regional' and {job}='9'",
        setToName: "val",
        setValue: "4000"
      },
      //Rising Star
      {
        type: "setvalue",
        expression: "{classificacao2} = 'Rising Star' and {job}='9'",
        setToName: "val",
        setValue: "6000"
      },
            //Prescritor
            {
              type: "setvalue",
              expression: "{classificacao2} = 'Prescritor' and {job}='10'",
              setToName: "val",
              setValue: "2500"
            },
            //KOL Nacional
            {
              type: "setvalue",
              expression: "{classificacao2} = 'KOL Nacional' and {job}='10'",
              setToName: "val",
              setValue: "4500"
            },
            //KOL Regional
            {
              type: "setvalue",
              expression: "{classificacao2} = 'KOL Regional' and {job}='10'",
              setToName: "val",
              setValue: "3500"
            },
            //Rising Star
            {
              type: "setvalue",
              expression: "{classificacao2} = 'Rising Star' and {job}='10'",
              setToName: "val",
              setValue: "4000"
            },
                  //Prescritor
      {
        type: "setvalue",
        expression: "{classificacao2} = 'Prescritor' and {job}='11'",
        setToName: "val",
        setValue: "2000"
      },
      //KOL Nacional
      {
        type: "setvalue",
        expression: "{classificacao2} = 'KOL Nacional' and {job}='11'",
        setToName: "val",
        setValue: "4500"
      },
      //KOL Regional
      {
        type: "setvalue",
        expression: "{classificacao2} = 'KOL Regional' and {job}='11'",
        setToName: "val",
        setValue: "3000"
      },
      //Rising Star
      {
        type: "setvalue",
        expression: "{classificacao2} = 'Rising Star' and {job}='11'",
        setToName: "val",
        setValue: "3500"
      },
            //Prescritor
            {
              type: "setvalue",
              expression: "{classificacao2} = 'Prescritor' and {job}='12'",
              setToName: "val",
              setValue: "0"
            },
            //KOL Nacional
            {
              type: "setvalue",
              expression: "{classificacao2} = 'KOL Nacional' and {job}='12'",
              setToName: "val",
              setValue: "0"
            },
            //KOL Regional
            {
              type: "setvalue",
              expression: "{classificacao2} = 'KOL Regional' and {job}='12'",
              setToName: "val",
              setValue: "0"
            },
            //Rising Star
            {
              type: "setvalue",
              expression: "{classificacao2} = 'Rising Star' and {job}='12'",
              setToName: "val",
              setValue: "0"
            },
                  //Prescritor
      {
        type: "setvalue",
        expression: "{classificacao2} = 'Prescritor' and {job}='13'",
        setToName: "val",
        setValue: "2000"
      },
      //KOL Nacional
      {
        type: "setvalue",
        expression: "{classificacao2} = 'KOL Nacional' and {job}='13'",
        setToName: "val",
        setValue: "4500"
      },
      //KOL Regional
      {
        type: "setvalue",
        expression: "{classificacao2} = 'KOL Regional' and {job}='13'",
        setToName: "val",
        setValue: "3000"
      },
      //Rising Star
      {
        type: "setvalue",
        expression: "{classificacao2} = 'Rising Star' and {job}='13'",
        setToName: "val",
        setValue: "3500"
      }

    ],
    pages: [
      {
        name: "FMV",
        elements: [
          {
            type: "text",
            name: "name",
            isRequired: true,
            title: "Nome:",
            validators: [
              {
                  type: "text",
              }
            ]
          },
          {
            type: "radiogroup",
            name: "profissional_medico",
            title: "Profissional médico?",
            isRequired: true,
            colCount: 0,
            choices: [
              "1|Sim",
              "2|Não"
            ]
          },
          {
            type: "text",
            name: "crm",
            isRequired: true,
            title: "CRM:",
            visibleIf: "{profissional_medico}='1'",
            validators: [
              {
                  type: "text",
              }
            ]
          },
          
          {
            type: "dropdown",
            name: "estado_crm",
            title: "Estado",
            visibleIf: "{profissional_medico}='1'",
            isRequired: true,
            colCount: 0,
            choices: [
                "AC",
                "AL",
                "AP",
                "AM",
                "BA",
                "CE",
                "DF",
                "ES",
                "GO",
                "MA",
                "MT",
                "MS",
                "MG",
                "PA",
                "PB",
                "PR",
                "PE",
                "PI",
                "RJ",
                "RN",
                "RS",
                "RO",
                "RR",
                "SC",
                "SP",
                "SE",
                "TO"
            ]
        },
        {
            type: "dropdown",
            name: "especialidades",
            title: "Especialidade médica: RESOLUÇÃO Nº 2.221 DE 23 DE NOVEMBRO DE 2018 do CONSELHO FEDERAL DE MEDICINA",
            visibleIf: "{profissional_medico}='1'",
            isRequired: true,
            colCount: 0,
            choices: [
              "Acupuntura",
"Alergia e imunologia",
"Anestesiologia",
"Angiologia",
"Cardiologia",
"Cirurgia cardiovascular",
"Cirurgia da mão",
"Cirurgia de cabeça e pescoço",
"Cirurgia do aparelho digestivo",
"Cirurgia geral",
"Cirurgia oncológica",
"Cirurgia pediátrica",
"Cirurgia plástica",
"Cirurgia torácica",
"Cirurgia vascular",
"Clínica médica",
"Coloproctologia",
"Dermatologia",
"Endocrinologia e metabologia",
"Endoscopia",
"Gastroenterologia",
"Genética médica",
"Geriatria",
"Ginecologia e obstetrícia",
"Hematologia e hemoterapia",
"Homeopatia",
"Infectologia",
"Mastologia",
"Medicina de emergência",
"Medicina de família e comunidade",
"Medicina do trabalho",
"Medicina de tráfego",
"Medicina esportiva",
"Medicina física e reabilitação",
"Medicina intensiva",
"Medicina legal e perícia médica",
"Medicina nuclear",
"Medicina preventiva e social",
"Nefrologia",
"Neurocirurgia",
"Neurologia",
"Nutrologia",
"Oftalmologia",
"Oncologia clínica",
"Ortopedia e traumatologia",
"Otorrinolaringologia",
"Patologia",
"Patologia clínica/medicina laboratorial",
"Pediatria",
"Pneumologia",
"Psiquiatria",
"Radiologia e diagnóstico por imagem",
"Radioterapia",
"Reumatologia",
"Urologia"
            ]
          },
          {
            type: "radiogroup",
            name: "servidor_publico",
            title: "O profissional é servidor público ou pessoa politicamente exposta?",
            isRequired: true,
            colCount: 0,
            choices: [
              "1|Sim",
              "2|Não"
            ]
          },

          {
            type: "radiogroup",
            name: "pos_graduacao",
            title: "O profissional possui ou está realizando pós-graduação Strictu Sensu (mestrado, doutorado, livre-docência)?",
            isRequired: true,
            colCount: 0,
            choices: [
              "1|Sim",
              "2|Não"
            ]
          },
          {
            type: "radiogroup",
            name: "associado",
            title: "O profissional está associado a centro universitário com possibilidade de progressão de carreira acadêmica?",
            isRequired: true,
            colCount: 0,
            choices: [
              "1|Sim",
              "2|Não"
            ]
          },

          {
            type: "radiogroup",
            name: "vinculo_instituicoes",
            title: "Vínculo com instituições de ensino e títulos",
            isRequired: true,
            colCount: 1,
            choices: [
              "30|Possui vínculo e é docente",
              "20|Possui vínculo, mas não é docente",
              "10|Não possui vínculo atualmente, mas já realizou pós-graduação stricto sensu",
              "0|Não possui vínculo, e possui apenas residência ou pós-graduação lato sensu",
            ]
          },

          {
            type: "radiogroup",
            name: "Participacao",
            title: "Participação em sociedades e associações médicas",
            isRequired: true,
            colCount: 1,
            choices: [
              "30|É ou já foi membro de diretoria de entidade nacional",
              "20|É ou já foi membro de diretoria de entidade regional",
              "10|Possui vínculo, sem cargo de diretoria",
              "0|Não possui vínculo"
            ]
          },

          {
            type: "radiogroup",
            name: "Producao_Cientifica",
            title: "Produção Científica (pode ser consultada no link: https://www.scopus.com/freelookup/form/author.uri ou perfil do autor disponível em: https://scholar.google.com)",
            isRequired: true,
            colCount: 1,
            choices: [
              "30|Produção científica relevante (acima de 500 citações)",
              "20|Produção científica com impacto mediano (entre 100 e 499 citações)",
              "10|Produção científica com pouco impacto (até 99 citações)",
              "0|Sem produção científica",
            ]
          },

          {
            type: "radiogroup",
            name: "saude",
            title: "Serviços de Saúde (para auxílio na pesquisa é possível utilizar o site [https://cnes.datasus.gov.br/](https://cnes.datasus.gov.br/))",
            isRequired: true,
            colCount: 1,
            choices: [
              "30|Tem ou já teve cargo na diretoria de Hospital ou chefia de departamento associado a Faculdade de Medicina; ou diretoria de Órgão de Saúde Federal",
              "20|Tem ou já teve cargo na diretoria de Hospital ou chefia de departamento associado a treinamento de Residência Médica, mas não ao ensino de graduandos em Medicina; ou diretoria de Órgão de Saúde Estadual",
              "10|Tem ou já teve cargo na diretoria de Hospital ou chefia de departamento de hospital público ou privado não classificado nos itens anteriores; ou diretoria de Órgão de Saúde Municipal ",
              "0|Nunca possuiu cargo na diretoria de Hospital ou chefia de Serviço de Saúde",
            ]
          },

          {
            type: "radiogroup",
            name: "tempo",
            title: "Tempo de formação",
            isRequired: true,
            colCount: 1,
            choices: [
              "30|15 anos ou mais",
              "20|10 a 15 anos",
              "10|5 a 10 anos",
              "0|Menos de 5 anos",
            ]
          },

          {
            type: "expression",
            name: "classificacao",
            title:"",
            visibleIf: "false",
            expression: "{tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes}",
        }

        ]
      },
      {
        name: "Job",
        elements: [
          {
            type: "dropdown",
            renderAs: "select2",
            name: "job",
            title: "Job",
            isRequired: true,
            colCount: 0,
            choices: [
                "1|Acompanhamento em reunião ANVISA",
                "2|Avaliação de protocolo de ensaio clínico",
                "3|Aula para Força de Vendas",
                "4|Aula Médica",
                "5|Board Científico",
                "6|Board Comercial",
                "7|Board de Acesso",
                "8|Consultoria",
                "9|Emissão de parecer / racional técnico",
                "10|Escrita de texto para material de marketing",
                "13|Reunião Regional/Local"
            ]
        },
        {
          name: "val",
          type: "text",
          title: "value",
          visibleIf: "false",
        },
        {
          "type": "html",
          "name": "text-1",
          "title": "Descrição",
          "visibleIf": "{job}='1'",
          "html": "Participação em reunião com a ANVISA para defesa de protocolo de ensaio clínico."
        },
        {
          "type": "html",
          "name": "income_intro",
          "visibleIf": "{job}='2'",
          "html": "Revisão do protocolo clínico para viabilidade da condução do ensaio."
        },
        {
          "type": "html",
          "name": "income_intro",
          "visibleIf": "{job}='3'",
          "html": "Aula ou Treinamento organizado pela GRUPO NC para formar / preparar membros da força de vendas."
        },
        {
          "type": "html",
          "visibleIf": "{job}='4'",
          "name": "income_intro",
          "html": "Aula ou Treinamento em congressos, simpósios, mini-meetings, speaker training, etc."
        },
        {
          "type": "html",
          "name": "income_intro",
          "visibleIf": "{job}='5'",
          "html": "Reunião de experts para aconselhamento de caráter científico."
        },
        {
          "type": "html",
          "name": "income_intro",
          "visibleIf": "{job}='6'",
          "html": "Reunião de experts para aconselhamento de caráter comercial."
        },
        {
          "type": "html",
          "name": "income_intro",
          "visibleIf": "{job}='7'",
          "html": "Reunião de tomadores de decisão para aconselhamento de acceso a mercado."
        },
        {
          "type": "html",
          "name": "income_intro",
          "visibleIf": "{job}='8'",
          "html": "Avaliação de apresentação/sinopse de projeto de pesquisa ou manuscrito de artigo;consultoria para atividades de marketing, científicas ou comerciais.",
        },
        {
          "type": "html",
          "name": "income_intro",
          "visibleIf": "{job}='9'",
          "html": "Escrever material técnico destinado a cumprimento de exigências regulatórias."
        },
        {
          "type": "html",
          "name": "income_intro",
          "visibleIf": "{job}='10'",
          "html": "Desenvolvimento de material técnico para apoio de ações de marketing."
        },
        {
          "type": "html",
          "name": "income_intro",
          "visibleIf": "{job}='11'",
          "html": "Escrever material técnico destinado a publicação em revistas científicas."
        },
        {
          "type": "html",
          "name": "income_intro",
          "visibleIf": "{job}='12'",
          "html": "Participar de evento científico como moderador ou apresentador."
        },
        {
          "type": "html",
          "name": "income_intro",
          "visibleIf": "{job}='13'",
          "html": "Reuniões pequenas de capitulos de Sociedades, Hospitais, Instituiçõess, etc."
        },

        {
            "name": "classificacao2",
            "type": "text",
            "title": "Classificação",
            // "isRequired": true,
            "enableIf": "{classificacao2} = teste" ,
        },

        // {
        //   "type": "html",
        //   "name": "income_intro1",
        //   "visibleIf": "{tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} <= 70",
        //   "html": "<h3>Classificação</h3><h4>Prescritor<h4>"
        // },

        // {
        //   "type": "html",
        //   "name": "income_intro2",
        //   "visibleIf": "{tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} >= 130 and !({tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} <= 130 and {tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} > 70 and {tempo} <= 20 and {pos_graduacao} = 1 and {associado} = 1 and !({tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} <= 130 and {tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} >= 70 and {tempo} >= 20 ))",
        //   "html": "<h3>Classificação</h3><h4>KOL Nacional<h4>"
        // },

        // {
        //   "type": "html",
        //   "name": "income_intro3",
        //   "visibleIf": "{tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} <= 130 and {tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} >= 70 and {tempo} >= 20",
        //   "html": "<h3>Classificação</h3><h4>KOL Regional<h4>"
        // },

        // {
        //   "type": "html",
        //   "name": "income_intro4",
        //   "visibleIf": "{tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} <= 130 and {tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} > 70 and {tempo} <= 20 and {pos_graduacao} = 1 and {associado} = 1 and !({tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} <= 130 and {tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} >= 70 and {tempo} >= 20 )",
        //   "html": "<h3>Classificação</h3><h4>Rising Star<h4>"
        // },

//exceção

        // {
        //   "type": "html",
        //   "name": "income_intro3",
        //   "visibleIf": "!({tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} <= 70) and !({tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} >= 130 and !({tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} <= 130 and {tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} > 70 and {tempo} <= 20 and {pos_graduacao} = 1 and {associado} = 1 and !({tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} <= 130 and {tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} >= 70 and {tempo} >= 20 ))) and !({tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} <= 130 and {tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} >= 70 and {tempo} >= 20) and !({tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} <= 130 and {tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} > 70 and {tempo} <= 20 and {pos_graduacao} = 1 and {associado} = 1 and !({tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} <= 130 and {tempo} + {saude} + {Producao_Cientifica} + {Participacao} + {vinculo_instituicoes} >= 70 and {tempo} >= 20 ))",
        //   "html": "<h3>Classificação</h3><h4>xKOL Regional<h4>"
        // },

        {
          "type": "expression",
          "name": "valor_minimo",
          "title": "Valor mínimo:",
          "expression": "{valor_sugerido} - ({valor_sugerido} * 0.20)",
          "displayStyle": "currency",
          "currency": "BRL",
          "startWithNewLine": true,
          visibleIf: "{job} notempty ",
        },
        {
          "type": "expression",
          "name": "valor_sugerido",
          "title": "Valor sugerido:",
          "displayStyle": "currency",
          "expression": "{val}",
          "currency": "BRL",
          "startWithNewLine": true,
          visibleIf: "{job} notempty ",
        },
        {
          "type": "expression",
          "name": "valor_maximo",
          "title": "Valor máximo:",
          "expression": "{valor_sugerido} + ({valor_sugerido} * 0.20)",
          "displayStyle": "currency",
          "currency": "BRL",
          "startWithNewLine": true,
          visibleIf: "{job} notempty ",
        },
        // {
        //   "type": "html",
        //   "name": "ph",
        //   "visibleIf": "{job}='8'",
        //   "html": "valores por hora.",
        //   "startWithNewLine": true
        // },

        {
            "name": "ph2",
            "type": "text",
            "title": "Observação",
            "visibleIf": "{job}='8'",
            "startWithNewLine": true,
            "enableIf": "{classificacao2} = teste" 
        },

        ],

      },

    ],
              completedHtml:"<p><strong>Nome:</strong> {name}</p><p><strong>Profissional médico:</strong> {profissional_medico}</p><p><strong>CRM:</strong> {crm}</p><p><strong>Estado </strong>{estado_crm}</p><p><strong>Especialidade médica </strong>{especialidades}</p><p><strong>O profissional é servidor público ou pessoa politicamente exposta? </strong>{servidor_publico}</p><p><strong>O profissional possui ou está realizando pós-graduação Strictu Sensu (mestrado, doutorado, livre-docência)?</strong> {pos_graduacao}</p><p><strong>O profissional está associado a centro universitário com possibilidade de progressão de carreira acadêmica?</strong> {associado}</p><p><strong>Vínculo com instituições de ensino e títulos</strong> {vinculo_instituicoes}</p><p><strong>Participação em sociedades e associações médicas</strong> {Participacao}</p><p><strong>Produção Científica (pode ser consultada no link: https://www.scopus.com/freelookup/form/author.uri ou perfil do autor disponível em: https://scholar.google.com)</strong> {Producao_Cientifica}</p><p><strong>Serviços de Saúde (para auxílio na pesquisa é possível utilizar o site https://cnes.datasus.gov.br/)</strong> {saude}</p><p><strong>Tempo de formação</strong> {tempo}</p><p><strong>Job</strong> {job}</p><p><strong>Classificação:</strong> {classificacao2}</p><p><strong>Valor mínimo:</strong> {valor_minimo}</p><p><strong>Valor sugerido:</strong> {valor_sugerido}</p><p><strong>Valor máximo:</strong> {valor_maximo}</p><p>{ph2}</p> <button onclick=\"window.print();\" class=\"noPrint\">Imprimir</button>"
              ,};    
              

//Create showdown markdown converter
//var showdown  = require('showdown');
    //converter = new showdown.Converter();

/*SurveyVue
    .onTextMarkdown
    .add(function (survey, options) {
      console.log(survey);
      console.log(options);
    });*/
              
              var model = new SurveyVue.Model(json);
    return {
      survey: model
    };

    
  }

  
};
</script>


<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
